import AntTypography, { TypographyProps } from 'antd/lib/typography';
import styled from 'styled-components';

const Typography = styled<TypographyProps>(AntTypography)``;

export default Typography;
